(function() { module.exports = window["@wordpress/element"]; }());